module.exports = __webpack_public_path__ + "static/media/apply-hover.0007d52f.png";